// extracted by mini-css-extract-plugin
export default {"container":"PostViewBanner-module__container--uhldj","banner":"PostViewBanner-module__banner--0Y2es","animatedBackground":"PostViewBanner-module__animatedBackground--xPJmd"};